/* LensTrove — Hero Carousel behavior
 * Auto-advance between slides (6500ms). Slide 2 card stack has its own inner
 * 2200ms cycle with pause-on-hover per design spec.
 */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.ltInited) return;
    root.dataset.ltInited = '1';

    var slides  = Array.prototype.slice.call(root.querySelectorAll('.lt-hero__slide'));
    var pagers  = Array.prototype.slice.call(root.querySelectorAll('.lt-hero__pager'));
    var prevBtn = root.querySelector('.lt-hero__arrow--prev');
    var nextBtn = root.querySelector('.lt-hero__arrow--next');

    if (slides.length <= 1) return;

    var slideInterval = parseInt(root.dataset.slideInterval, 10) || 6500;
    var active = 0;
    var timer  = null;
    var paused = false;

    function show(i) {
      active = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === active); });
      pagers.forEach(function (p, idx) { p.classList.toggle('is-active', idx === active); });

      // Force progress animation restart on the newly-active pager, sync duration with slideInterval.
      var progress = root.querySelector('.lt-hero__pager.is-active .lt-hero__pager-progress > span');
      if (progress) {
        progress.style.animation = 'none';
        // eslint-disable-next-line no-unused-expressions
        progress.offsetWidth;
        progress.style.animation = 'ltProgress ' + slideInterval + 'ms linear forwards';
      }

      // Match pager accent color to the active slide's accent.
      var accent = slides[active].dataset.accent;
      if (accent) root.style.setProperty('--lt-hero-accent', accent);

      // Swap hero bg to the active slide's bg.
      var bg = slides[active].dataset.bg;
      if (bg) root.style.backgroundColor = bg;

      // Toggle light-mode chrome (marquee/pagers/arrows) based on the active slide's data-light flag.
      root.classList.toggle('is-light', slides[active].dataset.light === 'true');
    }

    function advance() { show(active + 1); }
    function restartTimer() {
      clearInterval(timer);
      if (!paused) timer = setInterval(advance, slideInterval);
    }

    function goTo(i) { show(i); restartTimer(); }

    pagers.forEach(function (p, idx) {
      p.addEventListener('click', function () { goTo(idx); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(active + 1); });

    // Pause on user focus within the hero (keyboard nav, arrow hover).
    root.addEventListener('mouseenter', function () { paused = true;  root.classList.add('is-paused');  clearInterval(timer); });
    root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); restartTimer(); });
    root.addEventListener('focusin',    function () { paused = true;  root.classList.add('is-paused');  clearInterval(timer); });
    root.addEventListener('focusout',   function () {
      if (!root.contains(document.activeElement)) { paused = false; root.classList.remove('is-paused'); restartTimer(); }
    });

    // Pause when tab is hidden (don't burn battery cycling offscreen).
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearInterval(timer); }
      else if (!paused) { restartTimer(); }
    });

    show(0);
    restartTimer();
  }

  function initCardStack(root) {
    var stack = root.querySelector('.lt-s2__stack');
    if (!stack || stack.dataset.ltInited) return;
    stack.dataset.ltInited = '1';

    var cards = Array.prototype.slice.call(stack.querySelectorAll('.lt-s2__card'));
    var dots  = Array.prototype.slice.call(root.querySelectorAll('.lt-s2__dot'));
    if (cards.length <= 1) return;

    var cycleMs = 2200;
    var topIdx = 0;
    var timer = null;
    var hovered = false;

    function render() {
      cards.forEach(function (card, i) {
        var offset = (i - topIdx + cards.length) % cards.length;
        var depth = Math.min(offset, 3);
        var isTop = offset === 0;
        var visible = offset <= 3;
        card.classList.toggle('is-top', isTop);
        card.style.transform =
          'translate3d(' + (depth * 14) + 'px, ' + (depth * 10) + 'px, ' + (-depth * 40) + 'px) ' +
          'rotate(' + (depth * 2.5) + 'deg) ' +
          'scale(' + (1 - depth * 0.04) + ')';
        card.style.opacity = visible ? String(1 - depth * 0.15) : '0';
        card.style.zIndex  = String(cards.length - depth);
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === topIdx); });
    }

    function advance() { topIdx = (topIdx + 1) % cards.length; render(); }
    function restart() { clearInterval(timer); if (!hovered) timer = setInterval(advance, cycleMs); }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { topIdx = i; render(); restart(); });
    });
    cards[0].parentNode.parentNode.addEventListener('mouseenter', function () { hovered = true;  clearInterval(timer); });
    cards[0].parentNode.parentNode.addEventListener('mouseleave', function () { hovered = false; restart(); });

    render();
    restart();
  }

  function shuffleSlide2(root) {
    var poolEl = root.querySelector('.lt-s2__pool');
    if (!poolEl) return;
    var pool;
    try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
    if (!pool || pool.length < 5) return;

    var cards = root.querySelectorAll('.lt-s2__card');
    if (cards.length === 0) return;

    var shuffled = pool.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
    }

    for (var idx = 0; idx < cards.length; idx++) {
      var card = cards[idx];
      var item = shuffled[idx];
      if (!item) continue;

      if (card.tagName === 'A') card.setAttribute('href', item.url);

      var imgUrl = item.images[Math.floor(Math.random() * item.images.length)];
      var media = card.querySelector('.lt-s2__card-media');
      var img = media ? media.querySelector('img') : null;
      if (media) media.classList.add('lt-s2__card-media--photo');
      if (img) {
        img.setAttribute('src', imgUrl);
        img.setAttribute('alt', item.title || '');
      } else if (media) {
        // Convert SVG fallback to photo media, preserving overlay children.
        var overlayHtml = '';
        var overlays = media.querySelectorAll('.lt-s2__pricetag, .lt-s2__pin');
        for (var o = 0; o < overlays.length; o++) overlayHtml += overlays[o].outerHTML;
        media.innerHTML = '<img alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" src="' + imgUrl + '">' + overlayHtml;
      }

      var priceWasEl = card.querySelector('.lt-s2__pricetag-was');
      if (priceWasEl && item.priceWas) priceWasEl.textContent = item.priceWas + ' elsewhere';
      var priceNowEl = card.querySelector('.lt-s2__pricetag-now');
      if (priceNowEl && item.priceNow) priceNowEl.textContent = item.priceNow;

      var nameEl = card.querySelector('.lt-s2__card-name');
      if (nameEl) nameEl.textContent = item.title;
      var metaEl = card.querySelector('.lt-s2__card-meta');
      if (metaEl) {
        var metaParts = [];
        if (item.shape) metaParts.push(item.shape);
        if (item.color) metaParts.push(item.color);
        metaEl.textContent = metaParts.join(' · ');
      }
    }
  }

  function shuffleSlide1(root) {
    var poolEl = root.querySelector('.lt-s1__pool');
    if (!poolEl) return;
    var pool;
    try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
    if (!pool || pool.length < 4) return;

    var cards = root.querySelectorAll('.lt-s1__card');
    if (cards.length === 0) return;

    // Fisher–Yates shuffle
    var shuffled = pool.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
    }

    for (var idx = 0; idx < cards.length; idx++) {
      var card = cards[idx];
      var item = shuffled[idx];
      if (!item) continue;

      if (card.tagName === 'A') card.setAttribute('href', item.url);

      var imgUrl = item.images[Math.floor(Math.random() * item.images.length)];
      var media = card.querySelector('.lt-s1__card-media');
      var img   = media ? media.querySelector('img') : null;
      if (img) {
        img.setAttribute('src', imgUrl);
      } else if (media) {
        // Convert SVG-fallback media into a photo slot.
        media.classList.add('lt-s1__card-media--photo');
        media.innerHTML = '<img alt="" loading="lazy" src="' + imgUrl + '">';
      }

      var nameEl = card.querySelector('.lt-s1__card-name');
      if (nameEl) nameEl.textContent = item.title;
      var priceEl = card.querySelector('.lt-s1__card-price');
      if (priceEl) priceEl.textContent = item.price;
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-lt-hero]')).forEach(function (root) {
      initCarousel(root);
      shuffleSlide1(root);
      shuffleSlide2(root);
      initCardStack(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme-editor hot reload hook.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lt-hero]');
    if (root) {
      initCarousel(root);
      shuffleSlide1(root);
      shuffleSlide2(root);
      initCardStack(root);
    }
  });
})();
